import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import { cloneDeep } from '../../utils/lodash';

import get from 'lodash/get';
import set from 'lodash/set';

import { Tab, Tabs } from '@mui/material';

import DashboardIcon from '@mui/icons-material/Dashboard';
import TableChartIcon from '@mui/icons-material/TableChart';

import { viewDeepCopy } from './ViewDeepCopy';

import TableEdit from './Views/TableEdit/TableEdit';
import JelList from './components/JelList';
import LoaderNew from '../../common/LoaderNew';
import CommonStyles from '../../common/CommonStyles';
import DashboardEdit from './Views/DashboardEdit';
import DashboardsList from './components/DashboardsList';
import TrplFormEdit from './Views/TrplFormEdit/TrplFormEdit';
import UserMenuEdit from './UserMenuEdit';
import ComponentWrapper from '../../common/ComponentWrapper';
import FullScreenDialog from '../../common/FullScreenDialog';
import ActionConfirmation from '../../common/ActionConfirmation';

import { setUrlParameter, getUrlParameter, removeUrlParameter, getRandomInteger } from '../../utils';

import { addJel, updateJels, deleteJel, updateJelsSimple } from '../../reducer/jelsReducer';
import { jelTypes } from '../../constants';
import AccessRulesPage from './AccessRulesPage';
import ViewsDefaults from './ViewsDefaults';

const styles = {
  tab: {
    color: '#4E4C4C',
    fontWeight: 550,
  },
  tabIcon: {
    fontSize: 20,
  },
  paperContainer: {
    padding: '10px',
    backgroundColor: '#fff',
    boxShadow: '0px 3px 5px rgba(0, 0, 2, 0.05)',
  },
  ...CommonStyles,
};

const newTbl = {
  concept: 0,
  title: '',
  show_pids: [],
  sort_pid: '',
  sort_by: '',
  rowsToShow: 50,
  show_create_node: true,
};

const newFrm = {
  concept: null,
  title: '',
  groups: [],
};

const newDshbrd = {
  title: '',
  group: '',
  rows: [],
};

const newMenu = {
  menu: [
    {
      title: '',
      buttons: [
        {
          title: 'Link title',
          url: '/linkurl',
          icon: 'star',
        },
      ],
    },
  ],
  group: [],
};

class UiEditPage extends ComponentWrapper {
  state = {
    tbls: [],
    frms: [],
    jelData: {},
    nodesData: {},
    subs_accs: [],
    dashboards: [],
    user_menus: [],
    tab: jelTypes.table,
    subTab: jelTypes.dashboard,
    isDataLoaded: false,
    dashboardsListData: {},
    dashboardsByConcept: {},
    deleteJelModal: {
      open: false,
    },
    modalData: {
      isOpened: false,
      type: '',
      data: {},
    },
    isAllDataLoaded: false,
  };

  componentDidMount = () => {
    document.title="Edit UI | Milkyweb";

    const tab = getUrlParameter('tab');
    const subTab = getUrlParameter('sub_tab');

    if (subTab) {
      this.setState({ subTab });
    }
    if (tab) {
      this.setState({ tab });
    } else {
      setUrlParameter('tab', jelTypes.table);
      this.setState({ tab: jelTypes.table });
    }
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.props.isMetaLoaded && !this.state.isAllDataLoaded) {
      this.setState({ isAllDataLoaded: true }, () => {
        this.getData();
      });
    }
  };

  getData = () => {
    const { setup } = this.props;
    const { tables, forms, importedTables, importedForms, jelData } = this.props.jels;

    const nodes = [];

    //collect nodes, that are used in jels
    if (jelData) {
      tables.concat(forms, importedTables, importedForms).forEach((jelId) => {
        const conceptId = jelData[jelId] && jelData[jelId].concept;

        if (conceptId && !nodes.includes(conceptId)) nodes.push(conceptId);
      });
    }

    const dashboardConceptId = getUrlParameter('concept');
    if (dashboardConceptId && !nodes.includes(dashboardConceptId)) nodes.push(dashboardConceptId);

    const data = {
      api_key: setup.id,
      nesting: 2,
      filter: {
        nodes,
        page: 1,
        limit: 100,
      },
      sorter: {
        sort_pid: '',
        sort_by: '',
      },
    };

    this.postWithData({
      url: `/pnkqry3`,
      data,
      cb: (data) => {
        if (!data || (data && data._status === 'error')) {
          console.log(data);
          this.setState({ isDataLoaded: true });
        } else {
          this.setState({
              nodesData: data.nodes,
              isDataLoaded: true,
            }, () => {
              const jelId = getUrlParameter('id');
              let type = getUrlParameter('tab');

              if (type === 'dashboard_form') type = 'form';

              if (jelId && type) {
                let modalData = {
                  type,
                  data: {},
                  isOpened: true,
                };

                const jel = jelData[jelId];
                if (jel) modalData.data = jel;

                this.toggleEditModal(modalData);
              } else if (dashboardConceptId && type === 'dashboard') {
                const { jels } = this.props;

                let dashboard;

                jels.dashboards.forEach((dashboardId) => {
                  if (jels.jelData[dashboardId].acc_concept === +dashboardConceptId)
                    dashboard = jels.jelData[dashboardId];
                });

                const dashboardConcept = data.nodes[dashboardConceptId];

                let modalData = {
                  dashboard,
                  isOpened: true,
                  type: jelTypes.dashboard,
                  concept: dashboardConcept,
                };

                if (dashboardConcept) this.toggleEditDashboardModal(modalData);
              }
            }
          );
        }
      },
    });
  };

  // seems this function is not using anywhere, don't know why it was needed
  collectSubsData = (nodes, nodeTsubsData, data, path) => {
    if (!nodeTsubsData) return;
    nodeTsubsData.forEach((nodeId) => {
      const node = nodes[nodeId];

      set(data, [...path, nodeId], { ...node, isOpened: true });

      const newNodeSubsData = get(nodes, [nodeId, 'box', 't_subs']);

      if (nodeTsubsData) this.collectSubsData(nodes, newNodeSubsData, data, [...path, nodeId, 'children']);
    });
  };

  onTabClick = (tab) => {
    setUrlParameter('tab', tab);
    removeUrlParameter('sub_tab');

    this.setState({ tab, subTab: jelTypes.dashboard });
  };

  onSubTabClick = (subTab) => {
    setUrlParameter('sub_tab', subTab);

    this.setState({ subTab });
  }

  openDeleteJelModal = (jelId, type) => {
    const deleteJelModal = { ...this.state.deleteJelModal };
    const { jels } = this.props;

    deleteJelModal.open = true;
    deleteJelModal.jelId = jelId;
    deleteJelModal.contentText = `Delete ${type === jelTypes.form ? 'Form' : 'Table'}`;
    deleteJelModal.contentBoldText = `#${deleteJelModal.jelId} ${jels.jelData[deleteJelModal.jelId].title}?`;

    const isInAnotherJel = [];

    if (type === jelTypes.form) {
      jels.tables.forEach((tblId) => {
        const tbl = jels.jelData[tblId];

        if (tbl.buttons && tbl.buttons.editNode && jelId === tbl.buttons.editNode) {
          isInAnotherJel.push({ id: tblId, type: 'table' });
        }
      });

      jels.dashboards.forEach((dashboardId) => {
        const dashboard = jels.jelData[dashboardId];

        if (dashboard.views)
          dashboard.views.forEach((view) => {
            if (jelId && view.value === jelId) isInAnotherJel.push({ id: dashboard.id, type: jelTypes.dashboard });
          });
      });
    } else if (type === jelTypes.table) {
      jels.forms.forEach((frmId) => {
        const frm = jels.jelData[frmId];

        frm.groups.forEach((row) => {
          row.forEach((group) => {
            if (group.type === 'table' && group.tableId === jelId) isInAnotherJel.push({ id: frm.id, type: 'form' });
          });
        });
      });
    }

    deleteJelModal.isInAnotherJel = isInAnotherJel;

    this.setState({ deleteJelModal });
  };

  closeDeleteJelModal = () => {
    const deleteJelModal = { ...this.state.deleteJelModal };

    deleteJelModal.open = false;

    this.setState({
      deleteJelModal,
    });
  };

  deleteJel = (jelIdR, cb) => {
    const { jelId } = this.state.deleteJelModal;

    const jelIdToDelete = jelIdR ? jelIdR : jelId;

    this.closeDeleteJelModal();

    const jelKey = this.getJelsKeyByTab();

    if (jelIdToDelete && !isNaN(jelIdToDelete)) {
      this.get({
        url: `/del_jel?id=${jelIdToDelete}`,
        cb: () => {
          if (cb) cb();
          else this.props.deleteJel(jelIdToDelete, jelKey);
          this.props.updateJelsSimple();
        },
      });
    } else {
      this.props.deleteJel(jelIdToDelete, jelKey);
    }
  };

  getJelsKeyByTab = () => {
    const { tab, subTab } = this.state;

    return tab === jelTypes.table
      ? 'tables'
      : (tab === jelTypes.form) || (tab === jelTypes.dbForm)
        ? 'forms'
        : tab === jelTypes.dashboard && subTab && subTab === 'dashboard_form'
        ? 'forms'
          : tab === jelTypes.dashboard
            ? 'dashboards'
            : 'userMenus';
  };

  copyElement = (jel, cb) => {
    const elCopy = cloneDeep(jel);
    elCopy.id = `${getRandomInteger(10000, 50000)}_c`;
    elCopy.draft = true;
    elCopy.title = `(copy) ${elCopy.title}`;

    const jelsType = this.getJelsKeyByTab();

    this.props.addJel(elCopy, jelsType);
    setTimeout(() => {
      cb(elCopy.id)
    }, 600);
  };

  toggleEditModal = (modalData) => {
    if (modalData && modalData.data && modalData.data.id && !modalData.data.draft) {
      setUrlParameter('id', modalData.data.id);
    } else {
      if (modalData.type === jelTypes.dashboard) {
        removeUrlParameter('id');
      } else {
        removeUrlParameter('concept');
      }
    }

    this.setState({ modalData });
  };

  toggleEditDashboardModal = (modalData) => {
    if (modalData.isOpened) {
      setUrlParameter('concept', modalData.concept.id);
    } else {
      removeUrlParameter('concept');
    }

    this.setState({ modalData });
  };

  updateParentModalOnSave  = (jel) => {
    const { modalData } = this.state;
    const modalDataCopy = cloneDeep(modalData);

    modalDataCopy.data = cloneDeep(jel);

    this.setState({ modalData: modalDataCopy });
  };

  closeModal = () => {
    this.props.updateJels();

    removeUrlParameter('id');

    this.toggleEditModal({
      isOpened: false,
      data: {},
      type: '',
    });
  };

  onCopyViewBtnClick = (type, settings) => {
    delete settings.id;

    settings.title = `(copy) ${settings.title}`;

    if (type === jelTypes.form) {
      settings.groups.forEach((row) => {
        delete row.add_group_type;
      });
    }

    const backendType = (type === jelTypes.form) || (type === jelTypes.dbForm)
      ? 'trpls_frm'
      : type === jelTypes.table
        ? 'trpls_tbl'
        : type === jelTypes.userMenu
          ? 'user_menu'
          : 'dashboard';

    this.postWithData({
      url: `/rest/upd_jel?type=${backendType}`,
      data: settings,
      cb: (res) => {
        if (res.status === 'ok') {
          this.toggleEditModal({
            isOpened: false,
            data: {},
            type: '',
          });

          this.props.addJel(res[backendType], this.getJelsKeyByTab());

          setUrlParameter('id', res[backendType].id);
          setUrlParameter('tab', type);

          this.props.updateJels();

          this.getData();
        }
      },
    });
  };

  copyFrmInDashboard = (settings, cb) => {
    delete settings.id;

    settings.title = `(copy) ${settings.title}`;

    settings.groups.forEach((row) => {
      delete row.add_group_type;
    });

    this.postWithData({
      url: `/rest/upd_jel?type=trpls_frm`,
      data: settings,
      cb: (res) => {
        if (res.status === 'ok') {
          this.props.updateJels();

          cb(res.trpls_frm);
        }
      },
    });
  };

  saveNewView = (viewData, cb) => {
    const idId = viewData.id;
    if (!viewData) return
    delete viewData.id;

    const type = viewData.type === 'table' ? 'trpls_tbl' : 'trpls_frm';

    this.postWithData({
      data: viewData,
      url: `/rest/upd_jel?type=${type}`,
      cb: (data) => {
        if (data.status === 'ok') {
          console.log(data)

          if (cb) cb(data[type]);
        } else {
          console.log('id view copy error : ', idId);
        }
      },
      errorCb: () => {
        console.log('id view copy error : ', idId);
      }
    });
  };

  saveNewDefaultView = (viewData, cb) => {
    if (!viewData) return

    this.postWithData({
      data: viewData,
      url: `/rest/upd_jel?type=def_frms`,
      cb: (data) => {
        if (data.status === 'ok') {
          console.log(data);
          this.props.updateJelsSimple();

          if (cb) cb();
        }
      },
      errorCb: () => {
        console.log('Rule for defalut view not created', 'viewData', viewData);
        if (cb) cb();
      }
    });
  };

  deepCopyView = (initialViewId, usedViews, cb) => {
    viewDeepCopy(initialViewId, usedViews, this.saveNewView)
    .then(({ newViews, viewsChangedTo, newInitialView }) => {
      // Once fetchData returns, process the data
      console.log("New Views:", newViews, Object.keys(newViews).length);
      console.log("Views Changed To:", viewsChangedTo, Object.keys(viewsChangedTo).length);
      
      if (newViews && Object.values(newViews).length)
      Object.values(newViews).forEach(viewData => {
        const type = viewData.type === 'table' ? 'trpls_tbl' : 'trpls_frm';

          this.postWithData({
            data: viewData,
            url: `/rest/upd_jel?type=${type}`,
            cb: (data) => {
              if (data.status === 'ok') 
                console.log(data);
              else {
                if (cb) cb();
              }
            }
          });
      });
      if (cb) cb();
      setTimeout(() => {
        window.open(`http://${window.location.host}/ui_edit?tab=${newInitialView.type}&id=${newInitialView.id}`, "_blank",  "noreferrer noopener");
      }, 500);
    })
    .catch(error => {
      console.error('Error fetching data:', error);
      if (cb) cb();
    });
  };

  render() {
    const { classes, jels, setup_accounts, accounts_tbox, light_meta_and_ops } = this.props;
    const { tab, subTab, modalData, nodesData, isDataLoaded, deleteJelModal } = this.state;

    const elementNameByType =
      modalData.type === jelTypes.table
        ? 'table'
        : modalData.type === jelTypes.form
          ? 'form'
          : modalData.type === jelTypes.dashboard
            ? jelTypes.dashboard
            : modalData.type === jelTypes.dbForm
            ? 'form'
              : modalData.type === 'user_menu'
                ? 'user menu'
                : '';

    const jelListProps = {
      type: subTab === jelTypes.dbForm ? 'form' : tab,
      nodesData,
      deleteJel: this.props.deleteJel,
      copyElement: this.copyElement,
      getJelsKeyByTab: this.getJelsKeyByTab,
      toggleEditModal: this.toggleEditModal,
      openDeleteJelModal: this.openDeleteJelModal,
      toggleEditDashboardModal: this.toggleEditDashboardModal,
      rows:
        tab === jelTypes.table
          ? jels.tables.filter(id => !jels.importedTables.includes(id))
          : tab === jelTypes.form
            ? jels.forms.filter(id => !jels.jelData[id].is_dashboard && !jels.importedForms.includes(id))
            : tab === jelTypes.dashboard && subTab === jelTypes.dashboard
              ? jels.dashboards
              : tab === jelTypes.dashboard && subTab === jelTypes.dbForm
              ? jels.forms.filter(id => jels.jelData[id].is_dashboard && !jels.importedForms.includes(id))
                : jels.userMenus,
      newModalData:
        tab === jelTypes.table
          ? { ...newTbl }
          : tab === jelTypes.form
            ? { ...newFrm }
            : tab === jelTypes.dashboard && subTab === jelTypes.dashboard
              ? { ...newDshbrd }
              : tab === jelTypes.dashboard && subTab === jelTypes.dbForm
                ? { ...newFrm, is_dashboard: true }
                : { ...newMenu },
    };

    return (
      <div style={{ marginBottom: '200px'}}>
        <ActionConfirmation
          modalData={deleteJelModal}
          acceptHandler={this.deleteJel}
          onClose={this.closeDeleteJelModal}
        />

        <Tabs className={classes.tabs} style={{ background: '#fff' }} value={tab} onChange={(e, value) => this.onTabClick(value)}>
          <Tab
            value={jelTypes.table}
            label="Tables"
            icon={<TableChartIcon className={classes.tabIcon} style={{ color: '#DE3939' }} />}
          />

          <Tab
            value={jelTypes.form}
            label="Forms"
            icon={
              <img
                src="/images/ui-edit-frm.svg"
                alt="ui-edit-frm"
                style={{
                  width: '16px',
                  height: '16px',
                }}
              />
            }
          />

          <Tab
            label="Dashboards"
            value={jelTypes.dashboard}
            icon={<DashboardIcon className={classes.tabIcon} style={{ color: '#8F24B7' }} />}
          />
        </Tabs>

        <div style={{ padding: '1px 20px 20px 20px' }}>
          <FullScreenDialog
            title={
              modalData && modalData.type !== jelTypes.dashboard && modalData.data
                ? `${!isNaN(modalData.data.id) ? 'Edit' : 'Create'} ${elementNameByType} ${modalData.data.title} | ${(modalData.data.id && !isNaN(modalData.data.id)) ? `| ${modalData.data.id}` : ''}`

                  : modalData.type === jelTypes.dashboard && modalData.old
                    ? 'Edit old dashboard': modalData.concept && modalData.concept.title
                    ? `${modalData.concept.title} group dashboard editing` : ''
            }
            onClose={this.closeModal}
            isOpen={modalData.isOpened}
            paperFullScreenStyles={classes.trplFormPaper}
            disableContainerPadding={modalData.type === jelTypes.form}
          >
            {modalData.type === jelTypes.table ? (
              <TableEdit
                modalIndex={1}
                accounts_tbox={accounts_tbox.nodes}
                setup_accounts={setup_accounts}
                settings={modalData.data}
                parentJelId={modalData.data.id}
                deepCopyView={this.deepCopyView}
                onCopyViewBtnClick={this.onCopyViewBtnClick}
                updateParentModalOnSave={this.updateParentModalOnSave}
              />
            ) : modalData.type === jelTypes.form || (modalData.type === jelTypes.dashboard && subTab === jelTypes.dbForm) ? (
              <TrplFormEdit
                modalIndex={1}
                accounts_tbox={accounts_tbox.nodes}
                setup_accounts={setup_accounts}
                nodesData={nodesData}
                form={modalData.data}
                deepCopyView={this.deepCopyView}
                onCopyViewBtnClick={this.onCopyViewBtnClick}
                updateParentModalOnSave={this.updateParentModalOnSave}
              />
            ) : modalData.type === jelTypes.dashboard ? (
              <DashboardEdit
                modalIndex={1}
                accounts_tbox={accounts_tbox.nodes}
                setup_accounts={setup_accounts}
                concept={modalData.concept}
                dashboard={modalData.dashboard}
                deepCopyView={this.deepCopyView}
                onCopyViewBtnClick={this.onCopyViewBtnClick}
                copyFrmInDashboard={this.copyFrmInDashboard}
              />
            ) : modalData.type === 'user_menu' ? (
              <UserMenuEdit userMenu={modalData.data} />
            ) : null}
          </FullScreenDialog>

          {isDataLoaded && tab === jelTypes.form ?
            <React.Fragment>
              <ViewsDefaults
                jels={jels}
                classes={classes}
                deleteJel={this.deleteJel}
                saveNewDefaultView={this.saveNewDefaultView}
                setupRbox={light_meta_and_ops && light_meta_and_ops.setup_rbox_light}
              />
            </React.Fragment>
          : null}

          {!isDataLoaded ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: '200px',
              }}
            >
              <LoaderNew />
            </div>
          ) : (tab === jelTypes.dashboard) ? (
            <React.Fragment>
              <Tabs className={classes.tabs} value={subTab} onChange={(e, value) => this.onSubTabClick(value)}>
                <Tab
                  value={jelTypes.dashboard}
                  label="Dashboards by Accounts"
                />
                <Tab
                  value={jelTypes.dbForm}
                  label="Dashboards Forms"
                />
                <Tab
                  value={jelTypes.accessRules}
                  label="Access rules"
                />
              </Tabs>

              {subTab === jelTypes.dbForm ?
                <JelList
                  isDashboard
                  {...jelListProps}
                />
              : subTab === jelTypes.accessRules ?
                <AccessRulesPage/>
              :
                <DashboardsList
                  accounts_tbox={accounts_tbox.nodes}
                  setup_accounts={setup_accounts}
                  {...jelListProps}
                  toggleEditModal={this.toggleEditModal}
                  toggleEditDashboardModal={this.toggleEditDashboardModal}
                />
              }
            </React.Fragment>
          ) : <JelList {...jelListProps} />}
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  jels: state.jels,
  setup: state.meta.setup,
  isMetaLoaded: state.meta.loaded,
  accounts_tbox: state.meta.accounts_tbox,
  setup_accounts: state.meta.setup_accounts,
  light_meta_and_ops: state.meta.light_meta_and_ops,
}), {
  addJel,
  deleteJel,
  updateJels,
  updateJelsSimple,
})(withStyles(styles)(UiEditPage));
